import { PersonaRequestBody } from './PersonaRequestBody';

/**
 * @public
 */
export interface StopBlProfilingRequestBody extends PersonaRequestBody {
  reverse: boolean;
}
